// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Left panel ── */
.ill-left-panel {
  position: relative;
  width: calc(100% - 2rem);
  height: calc(100vh - 2rem);
  margin: 1rem;
  border-radius: 24px;
  overflow: hidden;
  background: #0a6cf5;
}

/* Carousel slides */
.ill-carousel {
  position: absolute;
  inset: 0;
}
.ill-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.9s cubic-bezier(0.4, 0, 0.2, 1);
}
.ill-slide.active {
  opacity: 1;
}
.ill-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Dot indicators */
.ill-dots {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}
.ill-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.45);
  transition: background 0.3s, transform 0.3s;
  cursor: pointer;
}
.ill-dot.active {
  background: #fff;
  transform: scale(1.3);
}

/* ── Right panel ── */
.ill-right-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  padding: 0 2.5rem;
  background: #ffffff;
}

/* Card */
.ill-card {
  background: #fff;
  border-radius: 20px;
  padding: 2.5rem 2rem 2rem;
  box-shadow: 0 4px 32px rgba(10, 108, 245, 0.08), 0 1px 4px rgba(0,0,0,0.04);
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
}

/* Brand header */
.ill-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1.75rem;
}
.ill-brand-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
}
.ill-brand-text {
  font-size: 1.15rem;
  font-weight: 700;
  color: #111;
  letter-spacing: -0.2px;
  line-height: 1;
}
.ill-brand-text span {
  font-weight: 400;
  color: #555;
}

/* Divider */
.ill-divider {
  height: 1px;
  background: #f0f0f0;
  margin-bottom: 1.75rem;
}

/* Title block */
.ill-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #111;
  letter-spacing: -0.5px;
  line-height: 1.2;
  margin-bottom: 0.35rem;
}
.ill-subtitle {
  font-size: 0.875rem;
  color: #888;
  margin-bottom: 1.75rem;
}

/* Footer inside card */
.ill-footer {
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid #f0f0f0;
  font-size: 0.75rem;
  color: #bbb;
  text-align: center;
}

/* ── Splash / loading overlay ── */
.ill-splash {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
}
.ill-splash.visible {
  animation: splashFadeInOut 3s ease-out forwards;
}
@keyframes splashFadeInOut {
  0%   { opacity: 0; }
  25%  { opacity: 1; }
  75%  { opacity: 1; }
  100% { opacity: 0; }
}
.ill-splash img {
  width: 220px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/authentication/components/IlllustrationLayout/illustrationLayout.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qDAAqD;AACvD;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,2EAA2E;EAC3E,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,+CAA+C;AACjD;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":["/* ── Left panel ── */\n.ill-left-panel {\n  position: relative;\n  width: calc(100% - 2rem);\n  height: calc(100vh - 2rem);\n  margin: 1rem;\n  border-radius: 24px;\n  overflow: hidden;\n  background: #0a6cf5;\n}\n\n/* Carousel slides */\n.ill-carousel {\n  position: absolute;\n  inset: 0;\n}\n.ill-slide {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transition: opacity 0.9s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.ill-slide.active {\n  opacity: 1;\n}\n.ill-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Dot indicators */\n.ill-dots {\n  position: absolute;\n  bottom: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n}\n.ill-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.45);\n  transition: background 0.3s, transform 0.3s;\n  cursor: pointer;\n}\n.ill-dot.active {\n  background: #fff;\n  transform: scale(1.3);\n}\n\n/* ── Right panel ── */\n.ill-right-panel {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100vh;\n  padding: 0 2.5rem;\n  background: #ffffff;\n}\n\n/* Card */\n.ill-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 2.5rem 2rem 2rem;\n  box-shadow: 0 4px 32px rgba(10, 108, 245, 0.08), 0 1px 4px rgba(0,0,0,0.04);\n  width: 100%;\n  max-width: 380px;\n  margin: 0 auto;\n}\n\n/* Brand header */\n.ill-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 1.75rem;\n}\n.ill-brand-icon {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n.ill-brand-text {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #111;\n  letter-spacing: -0.2px;\n  line-height: 1;\n}\n.ill-brand-text span {\n  font-weight: 400;\n  color: #555;\n}\n\n/* Divider */\n.ill-divider {\n  height: 1px;\n  background: #f0f0f0;\n  margin-bottom: 1.75rem;\n}\n\n/* Title block */\n.ill-title {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #111;\n  letter-spacing: -0.5px;\n  line-height: 1.2;\n  margin-bottom: 0.35rem;\n}\n.ill-subtitle {\n  font-size: 0.875rem;\n  color: #888;\n  margin-bottom: 1.75rem;\n}\n\n/* Footer inside card */\n.ill-footer {\n  margin-top: 2rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid #f0f0f0;\n  font-size: 0.75rem;\n  color: #bbb;\n  text-align: center;\n}\n\n/* ── Splash / loading overlay ── */\n.ill-splash {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n}\n.ill-splash.visible {\n  animation: splashFadeInOut 3s ease-out forwards;\n}\n@keyframes splashFadeInOut {\n  0%   { opacity: 0; }\n  25%  { opacity: 1; }\n  75%  { opacity: 1; }\n  100% { opacity: 0; }\n}\n.ill-splash img {\n  width: 220px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
